/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout: React.FC = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div
        style={{
          margin: `0 auto`,
          maxWidth: 1200,
          padding: `0px 1.0875rem 1.45rem`,
          paddingTop: 0,
        }}
      >
        <main
          style={{
            display: "inline-block",
            width: "100%",
          }}
        >
          {children}
        </main>
        <footer>
          {" "}
          © {new Date().getFullYear()} Bryan Leister{" "}
          <a
            href="https://twitter.com/rtBoy"
            className="social"
            target="_blank"
            aria-label="Link to Twitter page"
            alt="Twitter logo"
          >
            <img
              src="/_twitter.png"
              alt="Twitter logo"
              height="40"
              width="40"
            />
          </a>
          <a
            href="https://www.instagram.com/bryanleister/"
            className="social"
            target="_blank"
            aria-label="Link to Instagram page"
            alt="Instagram logo"
          >
            <img
              src="/_insta.png"
              alt="Instagram logo"
              height="40"
              width="40"
            />
          </a>
          <a
            href="https://github.com/bryanrtboy"
            className="social"
            target="_blank"
            aria-label="Link to Github page"
            alt="Github logo"
          >
            <img src="/_git.png" alt="Github logo" height="40" width="40" />
          </a>
        </footer>
      </div>
    </>
  )
}

export default Layout
